const THRESHOLDS = [
  { range: [5001, Infinity], zoomStart: 95 },
  { range: [1001, 5000], zoomStart: 90 },
  { range: [501, 1000], zoomStart: 80 },
  { range: [101, 500], zoomStart: 70 },
  { range: [51, 100], zoomStart: 50 },
  { range: [0, 50], zoomStart: 0 },
];

export const calculateZoomStart = (valueArray) => {
  const arrayLength = valueArray.length;

  const matchedThreshold = THRESHOLDS.find(({ range }) => {
    return arrayLength >= range[0] && arrayLength <= range[1];
  });

  const zoomStart = matchedThreshold.zoomStart;
  return zoomStart;
};
